// extracted by mini-css-extract-plugin
export default {"ProfileUpperWrapper":"Style_ProfileUpperWrapper__GXzdh","profileimg":"Style_profileimg__Ec7Kp","applicationImage":"Style_applicationImage__WERzr"};